/** Échappement CSV + dates en ISO pour réimport stable. */
export function csvEscape(value: unknown): string {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.toISOString();
  }
  const str = String(value ?? '');
  if (str.includes('"') || str.includes(',') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function rowsToCsv(rows: Array<Record<string, unknown>>): string {
  if (!rows.length) return '';
  const headers = Object.keys(rows[0]);
  const headerLine = headers.map(csvEscape).join(',');
  const body = rows.map((row) => headers.map((h) => csvEscape(row[h])).join(','));
  return [headerLine, ...body].join('\n');
}

export function downloadCsv(filename: string, content: string): void {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/** Télécharge un CSV (lignes déjà mappées en objets plats). */
export function downloadRecordsCsv(baseFilename: string, rows: Array<Record<string, unknown>>): void {
  const csv = rowsToCsv(rows);
  if (!csv) return;
  downloadCsv(`${baseFilename}-${Date.now()}.csv`, csv);
}
